export class DuplicateRequestDto {
    public requestId: string = undefined;
    public number: string = undefined;
    public dotNumber: string = undefined;

}